import { render, staticRenderFns } from "./RunNotificationsModal.vue?vue&type=template&id=65be5a92&"
import script from "./RunNotificationsModal.vue?vue&type=script&lang=ts&"
export * from "./RunNotificationsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports